(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define([], factory);
  } else if (typeof exports !== "undefined") {
    factory();
  } else {
    var mod = {
      exports: {}
    };
    factory();
    global.footerLabels = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  module.exports = {
    fr: {
      main: [{
        label: 'Sites',
        href: null,
        links: [{
          label: 'ARTE VOD/DVD',
          kind: 'internal',
          href: 'https://boutique.arte.tv/',
          rel: null
        }, {
          label: 'ARTE Radio',
          kind: 'internal',
          href: 'https://www.arteradio.com/',
          rel: null
        }, {
          label: 'Coups de cœur culture',
          kind: 'internal',
          href: 'https://my.arte.tv/index.php?lang=fr&page=eventsFavorite',
          rel: null
        }, {
          label: 'En Thérapie',
          kind: 'internal',
          href: 'https://www.arte.tv/fr/videos/RC-020578/en-therapie/',
          rel: null
        }, {
          label: 'ARTE  fête ses 30 ans',
          kind: 'internal',
          href: 'https://www.arte.tv/fr/p/les-collectors/',
          rel: null
        }, {
          label: 'Super Fails',
          kind: 'internal',
          href: 'https://www.arte.tv/fr/videos/RC-022253/super-fails/',
          rel: null
        }]
      }, {
        label: 'Entreprise',
        href: null,
        links: [{
          label: 'Tout sur ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/',
          rel: 'nofollow'
        }, {
          label: 'Emplois et stages',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/particuliers-professionnels/#offres-demploi-et-de-stages',
          rel: 'nofollow'
        }, {
          label: "Appels d'offres",
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/appels-doffres/',
          rel: 'nofollow'
        }, {
          label: 'Aide & contact',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/nous-repondons-a-vos-questions/',
          rel: 'nofollow'
        }]
      }, {
        label: 'Infos légales',
        href: null,
        links: [{
          label: 'Gérer les cookies',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'ARTE et vos données personnelles',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/donnees-personnelles/',
          rel: 'nofollow'
        }, {
          label: 'Mentions légales et crédits',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/credits/',
          rel: 'nofollow'
        }, {
          label: 'CGU',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/conditions-generales-dutilisation-cgu/',
          rel: 'nofollow'
        }, {
          label: 'Accessibilité',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/accessibilite/',
          rel: 'nofollow'
        }, {
          label: 'Plan du site',
          kind: 'internal',
          href: 'https://www.arte.tv/fr/sitemap/',
          rel: null
        }]
      }, {
        label: 'Réseaux sociaux',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/artetv',
          rel: 'nofollow'
        }, {
          label: 'Instagram',
          kind: 'external',
          href: 'https://www.instagram.com/artefr',
          rel: 'nofollow'
        }, {
          label: 'Youtube',
          kind: 'external',
          href: 'https://www.youtube.com/arteplus7',
          rel: 'nofollow'
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/artefr',
          rel: 'nofollow'
        }]
      }],
      legacy: 'Tous droits de reproduction et de diffusion réservés © %YEAR% ARTE G.E.I.E. - ARTE G.E.I.E. 4, quai du chanoine Winterer CS 20035 F- 67080 Strasbourg Cedex'
    },
    de: {
      main: [{
        label: 'Websites',
        href: null,
        links: [{
          label: 'ARTE Edition',
          kind: 'internal',
          href: 'http://www.arte-edition.de/',
          rel: null
        }, {
          label: 'ARTE Magazin',
          kind: 'internal',
          href: 'https://www.arte-magazin.de',
          rel: null
        }, {
          label: 'ARTE Presse',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/presse/',
          rel: null
        }, {
          label: 'Kulturkalender',
          kind: 'internal',
          href: 'https://my.arte.tv/index.php?lang=de&page=eventsFavorite',
          rel: null
        }, {
          label: 'In Therapie',
          kind: 'internal',
          href: 'https://www.arte.tv/de/videos/RC-020578/in-therapie/',
          rel: null
        }, {
          label: '30 Jahre ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/de/p/30-jahre/',
          rel: null
        }, {
          label: 'Super Fails',
          kind: 'internal',
          href: 'https://www.arte.tv/de/videos/RC-022253/super-fails/',
          rel: null
        }]
      }, {
        label: 'Unternehmen',
        href: null,
        links: [{
          label: 'Alles über ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/',
          rel: 'nofollow'
        }, {
          label: 'Jobs und Praktika',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/ihre-anliegen/#karriere',
          rel: 'nofollow'
        }, {
          label: 'Ausschreibungen',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/ausschreibungen/',
          rel: 'nofollow'
        }, {
          label: 'Hilfe & Kontakt',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/wir-beantworten-ihre-fragen/',
          rel: 'nofollow'
        }]
      }, {
        label: 'Rechtliche Informationen',
        href: null,
        links: [{
          label: 'Cookies verwalten',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'Datenschutz',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/arte-und-ihre-privatsphaere-im-internet/',
          rel: 'nofollow'
        }, {
          label: 'Impressum',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/impressum/',
          rel: 'nofollow'
        }, {
          label: 'Nutzungsbedingungen',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/allgemeine-nutzungsbedingungen/',
          rel: 'nofollow'
        }, {
          label: 'Neuer Rundfunkbeitrag',
          kind: 'internal',
          href: 'https://www.rundfunkbeitrag.de/',
          rel: 'nofollow'
        }, {
          label: 'Barrierefreiheit',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/de/barrierefreiheit/',
          rel: 'nofollow'
        }, {
          label: 'Seitenübersicht',
          kind: 'internal',
          href: 'https://www.arte.tv/de/sitemap/',
          rel: null
        }]
      }, {
        label: 'Soziale Medien',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/artede',
          rel: 'nofollow'
        }, {
          label: 'Instagram',
          kind: 'external',
          href: 'https://www.instagram.com/arte.tv',
          rel: 'nofollow'
        }, {
          label: 'Youtube',
          kind: 'external',
          href: 'https://www.youtube.com/ARTEde',
          rel: 'nofollow'
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/artede',
          rel: 'nofollow'
        }]
      }],
      legacy: 'Alle Rechte vorbehalten © %YEAR% G.E.I.E. - ARTE G.E.I.E. Postfach 1980 D-77679 KEHL'
    },
    en: {
      main: [{
        label: 'Corporate',
        href: null,
        links: [{
          label: 'About ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/',
          rel: 'nofollow'
        }, {
          label: 'Help & Contact',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/we-are-here-to-answer-your-questions/',
          rel: 'nofollow'
        }, {
          label: 'Contact us',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/users-guide/contact/',
          rel: 'nofollow'
        }, {
          label: 'Vacancies',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/professionals-individuals/#job-vacancies',
          rel: 'nofollow'
        }, {
          label: 'Public tenders',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/public-tenders/',
          rel: 'nofollow'
        }]
      }, {
        label: 'Legal information',
        href: null,
        links: [{
          label: 'Manage cookies',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'Online Privacy',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/arte-and-your-personal-data/',
          rel: 'nofollow'
        }, {
          label: 'Credits',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/credits/',
          rel: 'nofollow'
        }, {
          label: 'General Conditions of Use',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/general-conditions-of-use/',
          rel: 'nofollow'
        }, {
          label: 'Accessibility',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/en/accessibility/',
          rel: 'nofollow'
        }, {
          label: 'Site map',
          kind: 'internal',
          href: 'https://www.arte.tv/en/sitemap/',
          rel: null
        }]
      }, {
        label: 'Our favourites',
        href: null,
        links: [{
          label: '100 Years of the Atom',
          kind: 'internal',
          href: 'https://www.arte.tv/en/videos/087958-000-A/100-years-of-the-atom/',
          rel: null
        }, {
          label: 'ARTJACKING!',
          kind: 'internal',
          href: 'https://www.arte.tv/en/videos/RC-021400/artjacking/',
          rel: null
        }, {
          label: 'The Satoshi Mystery - The Story of Bitcoin',
          kind: 'internal',
          href: 'https://www.arte.tv/en/videos/RC-021581/the-satoshi-mystery/',
          rel: null
        }]
      }, {
        label: 'Social media',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/ARTEenglish',
          rel: 'nofollow'
        }, {
          label: 'Youtube',
          kind: 'external',
          href: 'https://www.youtube.com/channel/UCVogAsASqbceBmQMi1WA39g',
          rel: 'nofollow'
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/arteen',
          rel: 'nofollow'
        }]
      }],
      european: 'Co-funded by the European Union',
      legacy: 'All rights for reproduction and diffusion reserved - ARTE G.E.I.E. 4, quai du chanoine Winterer CS 20035F - 67080 Strasbourg Cedex - France'
    },
    es: {
      main: [{
        label: 'Secciones',
        href: null,
        links: [{
          label: 'Acerca de ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/',
          rel: null
        }, {
          label: 'Ayuda y contacto',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/todas-las-respuestas/',
          rel: null
        }, {
          label: 'Contacto',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/modo-de-empleo/contacto/',
          rel: null
        }, {
          label: 'Ofertas de empleo y de prácticas',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/particulares-profesionales/#ofertas-de-empleo-y-de-practicas',
          rel: null
        }, {
          label: 'Licitaciones',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/licitaciones/',
          rel: null
        }]
      }, {
        label: 'Aspectos legales',
        href: null,
        links: [{
          label: 'Gestionar las cookies',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'ARTE y tus datos personales',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/arte-y-tus-datos-personales/',
          rel: null
        }, {
          label: 'Créditos',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/creditos/',
          rel: null
        }, {
          label: 'Condiciones generales de uso',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/condiciones-generales-de-uso-cgu/',
          rel: null
        }, {
          label: 'Accesibilidad',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/es/accesibilidad/',
          rel: null
        }, {
          label: 'Mapa web',
          kind: 'internal',
          href: 'https://www.arte.tv/es/sitemap/',
          rel: null
        }]
      }, {
        label: 'Favoritos',
        href: null,
        links: [{
          label: 'El átomo: un siglo de radioactividad',
          kind: 'internal',
          href: 'https://www.arte.tv/es/videos/087958-000-A/el-atomo-un-siglo-de-radioactividad/',
          rel: null
        }, {
          label: 'ARTJACKING!',
          kind: 'internal',
          href: 'https://www.arte.tv/es/videos/RC-021400/artjacking/',
          rel: null
        }, {
          label: 'Satoshi, la historia del bitcóin',
          kind: 'internal',
          href: 'https://www.arte.tv/es/videos/RC-021581/satoshi-la-historia-del-bitcoin/',
          rel: null
        }, {
          label: 'Documentales de historia',
          kind: 'internal',
          href: 'https://www.arte.tv/es/articles/documentales-de-historia-1',
          rel: null
        }]
      }, {
        label: 'Redes sociales',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/ARTEenespanol',
          rel: null
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/arteesp',
          rel: null
        }]
      }],
      european: 'Cofinanciado por la Unión Europea',
      legacy: 'Reservados todos los derechos de reproducción y difusión - ARTE G.E.I.E. 4, quai du chanoine Winterer CS 20035F - 67080 Strasbourg Cedex - France'
    },
    pl: {
      main: [{
        label: 'Informacje ogólne',
        href: null,
        links: [{
          label: 'O nas',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/',
          rel: 'nofollow'
        }, {
          label: 'Pomoc i kontakt',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/odpowiadamy-na-wasze-pytania/',
          rel: 'nofollow'
        }, {
          label: 'Kontakt',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/instrukcja-obslugi/kontakt/',
          rel: 'nofollow'
        }, {
          label: 'Kariera',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/osoby-prywatne-firmy/#oferty-pracy-i-stazu',
          rel: 'nofollow'
        }, {
          label: 'Przetargi',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/przetargi/',
          rel: 'nofollow'
        }]
      }, {
        label: 'Informacje prawne',
        href: null,
        links: [{
          label: 'Pliki cookie',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'Polityka prywatności',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/polityka-prywatnosci/',
          rel: 'nofollow'
        }, {
          label: 'Stopka',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/stopka/',
          rel: 'nofollow'
        }, {
          label: 'Warunki użytkowania',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/ogolne-warunki-uzytkowania/',
          rel: 'nofollow'
        }, {
          label: 'Dostępność cyfrowa bez barier',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/pl/dostepnosc-cyfrowa-bez-barier/',
          rel: 'nofollow'
        }, {
          label: 'Mapa strony',
          kind: 'internal',
          href: 'https://www.arte.tv/pl/sitemap/',
          rel: null
        }]
      }, {
        label: 'Wybrane dla Ciebie',
        href: null,
        links: [{
          label: 'Watani: My Homeland!',
          kind: 'internal',
          href: 'https://www.arte.tv/pl/videos/102520-000-A/watani-my-homeland-2016/',
          rel: null
        }, {
          label: 'ARTJACKING!',
          kind: 'internal',
          href: 'https://www.arte.tv/pl/videos/RC-021400/artjacking/',
          rel: null
        }, {
          label: 'Satoshi - historia bitcoina',
          kind: 'internal',
          href: 'https://www.arte.tv/pl/videos/RC-021581/satoshi-historia-bitcoina/',
          rel: null
        }]
      }, {
        label: 'Media społecznościowe',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/ARTEpopolsku',
          rel: 'nofollow'
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/artepl',
          rel: 'nofollow'
        }]
      }],
      european: 'Program jest współfinansowany ze środków Unii Europejskiej',
      legacy: 'Wszelkie prawa zastrzeżone - ARTE G.E.I.E. 4, quai du chanoine Winterer CS 20035F - 67080 Strasbourg Cedex - France'
    },
    it: {
      main: [{
        label: 'Corporate',
        href: null,
        links: [{
          label: 'Tutto su ARTE',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/',
          rel: 'nofollow'
        }, {
          label: 'FAQ',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/rispondiamo-alle-vostre-domande/',
          rel: 'nofollow'
        }, {
          label: 'Contatti',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/arte-istruzioni-per-luso/desideri-contattare-arte/',
          rel: 'nofollow'
        }, {
          label: 'Offerte di lavoro',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/privati-aziende/#offerte-di-lavoro-e-tirocini',
          rel: 'nofollow'
        }, {
          label: 'Bandi di gara',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/privati-aziende/#offerte-di-lavoro-e-tirocini',
          rel: 'nofollow'
        }]
      }, {
        label: 'Informazioni legali',
        href: null,
        links: [{
          label: 'Gestione cookies',
          kind: 'cookie',
          href: null,
          rel: null
        }, {
          label: 'ARTE e la tua privacy',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/arte-e-la-tua-privacy/',
          rel: 'nofollow'
        }, {
          label: 'Crediti',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/credits/',
          rel: 'nofollow'
        }, {
          label: 'Condizioni generali d’utilizzo',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/condizioni-generali-dutilizzo/',
          rel: 'nofollow'
        }, {
          label: 'Accessibilità',
          kind: 'internal',
          href: 'https://www.arte.tv/sites/corporate/it/accessibilita/',
          rel: 'nofollow'
        }, {
          label: 'Site map',
          kind: 'internal',
          href: 'https://www.arte.tv/it/sitemap/',
          rel: null
        }]
      }, {
        label: 'Scelti per voi',
        href: null,
        links: [{
          label: "Il nostro 'amico' atomo",
          kind: 'internal',
          href: 'https://www.arte.tv/it/videos/087958-000-A/il-nostro-amico-atomo/',
          rel: null
        }, {
          label: 'ARTJACKING!',
          kind: 'internal',
          href: 'https://www.arte.tv/it/videos/RC-021400/artjacking/',
          rel: null
        }, {
          label: 'Il mistero Satoshi - Alle origini dei Bitcoin',
          kind: 'internal',
          href: 'https://www.arte.tv/it/videos/RC-021581/il-mistero-satoshi-alle-origini-dei-bitcoin/',
          rel: null
        }]
      }, {
        label: 'Social media',
        href: null,
        links: [{
          label: 'Facebook',
          kind: 'external',
          href: 'https://www.facebook.com/ARTEita',
          rel: 'nofollow'
        }, {
          label: 'Twitter',
          kind: 'external',
          href: 'https://www.twitter.com/arteita',
          rel: 'nofollow'
        }]
      }],
      european: 'Progetto co-finanziato dall’Unione europea',
      legacy: 'All rights for reproduction and diffusion reserved - ARTE G.E.I.E. 4, quai du chanoine Winterer CS 20035F - 67080 Strasbourg Cedex - France'
    },
    partners: [{
      id: 'zdf',
      label: 'ZDF',
      href: 'http://www.zdf.de'
    }, {
      id: 'ard',
      label: 'ARD',
      href: 'http://www.ard.de'
    }, {
      id: 'ffl',
      label: 'Film Fund Luxembourg',
      href: 'http://www.filmfund.lu'
    }, {
      id: 'rtbf',
      label: 'RTBF',
      href: 'http://www.rtbf.be'
    }, {
      id: 'orf',
      label: 'ORF',
      href: 'http://orf.at'
    }, {
      id: 'rts',
      label: 'RTS',
      href: 'http://www.rts.ch'
    }, {
      id: 'ceskatelevize',
      label: 'Česká televize',
      href: 'http://www.ceskatelevize.cz'
    }, {
      id: 'rte',
      label: 'RTÉ',
      href: 'http://www.rte.ie'
    }, {
      id: 'rai',
      label: 'Rai',
      href: 'http://www.rai.it'
    }, {
      id: 'yle',
      label: 'Yle',
      href: 'http://yle.fi'
    }, {
      id: 'ert',
      label: 'ERT',
      href: 'http://www.ert.gr'
    }]
  };
});